import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@shared/components/ui/tooltip';
import { cn } from '@shared/lib/utils';
import { ReactNode } from 'react';

interface SimpleTooltipProps {
  trigger: ReactNode;
  content: ReactNode;
  delayDuration?: number;
  side?: 'top' | 'right' | 'bottom' | 'left';
  className?: string;
  disabled?: boolean;
}

export function SimpleTooltip({
  trigger,
  content,
  delayDuration = 200,
  side,
  className,
  disabled,
}: SimpleTooltipProps) {
  if (disabled) return trigger;
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger asChild className="cursor-pointer">
          {trigger}
        </TooltipTrigger>
        <TooltipPrimitive.Portal>
          <TooltipContent side={side} className={cn('max-w-xs', className)}>
            {content}
          </TooltipContent>
        </TooltipPrimitive.Portal>
      </Tooltip>
    </TooltipProvider>
  );
}
